// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__t8_GB","productName":"Table_productName__rSrKz"};